import { Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTransmissionControlModal extends Layout {
    panelTransmission: Panel;
    textboxDescription: Textbox;
}
